import tw from 'tailwind-styled-components'

const boxButton = `
relative 
w-full
cursor-default 
rounded-lg
text-left 
focus:outline-none 
focus-visible:border-indigo-500 
focus-visible:ring-2 
focus-visible:ring-white 
focus-visible:ring-opacity-75 
focus-visible:ring-offset-2 
focus-visible:ring-offset-orange-300
`
export const SelectSearchInput = tw.input`
h-[38px]
border
border-inputBorder
text-[13.35px]
font-medium
placeholder-darkGray/70
text-darkGray
rounded-lg
pl-10
outline-gray-200
`
const boxOptions = `
absolute
right-0
left-0
top-[45px]
max-h-60 
overflow-auto 
rounded-lg
py-1 
text-base 
border
shadow-lg 
ring-1 
ring-black 
ring-opacity-5 
focus:outline-none 
sm:text-sm
bg-white 
z-50
`
const Main = tw.div`
relative 
md:min-w-[166px] 
w-full
cursor-pointer
`
const WrapperButton = tw.div`
flex 
items-center 
gap-2 
w-full 
border
border-inputBorder
rounded-lg
pl-[14px]
pr-[15.5px]
h-[38px]
bg-white
`
const IconDown = tw.span`
pointer-events-none 
absolute 
inset-y-0 
-right-1 
flex 
items-center 
top-1
`
const listBoxOption = `
relative 
cursor-default 
select-none 
py-2 
pl-5 
pr-4
text-textSelect
`
const IconCheck = tw.span`
absolute 
inset-y-0 
left-0 
flex 
items-center 
pl-3 
text-yellow
`
const Span = tw.span`
block 
text-[14px] 
truncate 
pr-5
py-2
cursor-pointer
`
export {
  boxButton,
  boxOptions,
  Main,
  WrapperButton,
  IconDown,
  listBoxOption,
  IconCheck,
  Span,
}
